<template>
    <v-btn outlined small icon
    class=""
    :style="{ border: '1.5px solid' }"
    :color="fechaHoraCumplimiento ? 'success' : 'grey'"
    @click="toggleFechaCumplimiento">
      <v-icon small
      :color="fechaHoraCumplimiento ? 'success' : 'primary'">
        mdi-check
      </v-icon>
    </v-btn>
</template>
<script>
import mixFechaVencidos from './mixFechaVencidos';

export default {
  props: {
    acuerdo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      minutaAcuerdoEditar: {
        numero: this.acuerdo.numero,
        descripcion: this.acuerdo.descripcion,
        fechaLimite: this.acuerdo.fechaLimite,
        nombreReponsable: this.acuerdo.nombreReponsable,
        puestoResponsable: this.acuerdo.puestoResponsable,
        fechaHoraCumplimiento: this.acuerdo.fechaHoraCumplimiento,

      },
    };
  },
  mixins: [mixFechaVencidos],
  computed: {
    fechaHoraCumplimiento() {
      if (!this.acuerdo) return null;
      return this.acuerdo.fechaHoraCumplimiento;
    },
  },
  methods: {
    toggleFechaCumplimiento() {
      const ahora = new Date();
      ahora.setHours(ahora.getHours() - ahora.getTimezoneOffset() / 60);
      this.minutaAcuerdoEditar.fechaHoraCumplimiento = this
        .minutaAcuerdoEditar.fechaHoraCumplimiento
        ? null : ahora.toISOString();
      this.mixEditarAcuerdo();
    },
  },
};
</script>
<style scoped>
</style>
